module.exports = __webpack_public_path__ + "static/media/tang.004f0255.png";